// 입고사진(핸드폰 촬영) S3 업로드 — 입고처리 화면 uploadErrorImages() 와 같은 방식이다
// (브라우저 → S3 직접, Cognito 비인증 자격, public-read). 키는 import-photo/ 아래.
// 서버(/api/importPhoto/add)는 이 버킷의 import-photo/ 주소만 받는다.
import AWS from 'aws-sdk';

const BUCKET = 'elasticbeanstalk-ap-northeast-2-160290560268';
const REGION = 'ap-northeast-2';
const IDENTITY_POOL_ID = 'ap-northeast-2:19db1347-4000-4e66-973a-e2077f8cad1d';

// 핸드폰 원본(3~10MB)은 창고 와이파이에서 느리고 AI 판독에도 크다 → 긴 변 1920px JPEG 로 줄인다.
// 줄이기에 실패하면(지원 안 되는 형식 등) 원본을 그대로 올린다.
const MAX_SIDE = 1920;

function shrinkImage(file) {
  return new Promise((resolve) => {
    if (!file || !/^image\//.test(file.type) || /gif|svg/.test(file.type)) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
        const w = Math.round(img.naturalWidth * scale);
        const h = Math.round(img.naturalHeight * scale);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        canvas.toBlob((blob) => {
          URL.revokeObjectURL(url);
          resolve(blob && blob.size < file.size ? blob : file);
        }, 'image/jpeg', 0.85);
      } catch (e) {
        console.error('[importPhoto] 이미지 축소 실패 — 원본 업로드', e);
        URL.revokeObjectURL(url);
        resolve(file);
      }
    };
    img.onerror = (e) => {
      console.error('[importPhoto] 이미지 읽기 실패 — 원본 업로드', e);
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });
}

export async function uploadImportPhoto(file, reqpurchaseId) {
  AWS.config.update({
    region: REGION,
    credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: IDENTITY_POOL_ID })
  });
  const s3 = new AWS.S3({ apiVersion: '2006-03-01', params: { Bucket: BUCKET } });
  const body = await shrinkImage(file);
  const ext = body === file ? ((file.name || '').split('.').pop() || 'jpg').replace(/[^a-zA-Z0-9]/g, '').slice(0, 5) || 'jpg' : 'jpg';
  const key = `import-photo/${reqpurchaseId}/${Date.now()}_${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const r = await s3.upload({ Key: key, Body: body, ACL: 'public-read', ContentType: body.type || 'image/jpeg' }).promise();
  return r.Location;
}
